﻿import $ from "jquery";
import { ChangeAgendaDto } from "./changeAgendaDto";
import { EditableItemList, MovingDirection } from "./editableItemList";

// for layout 7
export class EditableMeetList extends EditableItemList<ChangeAgendaDto> {
    private readonly emptyGuidString = "00000000-0000-0000-0000-000000000000";

    init(divElementId: string) {
        this.itemList = $(`#${divElementId}`).data("initial");

        super.init(divElementId,"addMeetListButton");
    }

    protected drawItem(item: ChangeAgendaDto, itemId: number) {
        // == is placed here on purpose for comparison of string.empty
        const meetLogoUrl = item.MeetLogoId === this.emptyGuidString ? "" : `/fileasset/${item.MeetLogoId}`;

        const itemElement = "<div class='box'>" +
            "<div class='field has-addons is-pulled-right'>" +
            /*"<p class='control'>" +
            "<button id='agendaTopicFieldMoveUp-" + itemId + "' class='button is-small' data-tooltip='Agendapunkt nach oben schieben'>" +
            "<span class='icon is-small'><i class='fas fa-arrow-up'></i></span>" +
            "</button>" +
            "</p>" +
            "<p class='control'>" +
            "<button id='agendaTopicFieldMoveDown-" + itemId + "' class='button is-small' data-tooltip='Agendapunkt nach unten schieben'>" +
            "<span class='icon is-small'><i class='fas fa-arrow-down'></i></span>" +
            "</button>" +
            "</p>" +*/
            "<p class='control'>" +
            "<button id='agendaTopicFieldRemove-" + itemId + "' class='button is-small' data-tooltip='Agendapunkt entfernen'>" +
            "<span class='icon is-small'><i class='fas fa-times'></i></span>" +
            "</button>" +
            "</p>" +
            "</div>" +
            /*"<div class='control' data-tooltip='Titel des Meetingraumes'>" +
            "<label class='label'>Titel</label>" +
            "<input id='agendaTopicTitle-" + itemId + "' class='input' type='text' name='EventToChange.Agenda[" + itemId + "].Title' value='" + item.Title + "'>" +
            "</div><hr/>" +*/
            /*"<div class='columns'>" +
            "<div class='column'>" +
            "<div class='control' data-tooltip='Startzeitpunkt des Meetingraumes'>" +
            "<label class='label'>Von</label>" +
            "<input id='agendaTopicStartTime-" + itemId + "' class='input' type='datetime-local' name='EventToChange.Agenda[" + itemId + "].StartAt' value='" + this.getDateTimeString(item.StartAt) + "'>" +
            "</div>" +
            "</div>" +
            "<div class='column'>" +
            "<div class='control' data-tooltip='Endzeitpunkt des Meetingraumes'>" +
            "<label class='label'>Bis</label>" +
            "<input id='agendaTopicFinishTime-" + itemId + "' class='input' type='datetime-local' name='EventToChange.Agenda[" + itemId + "].FinishAt' value='" + this.getDateTimeString(item.FinishAt) + "'>" +
            "</div>" +
            "</div>" +
            "</div><hr/>" +*/
            /*"<div class='control' data-tooltip='Beschreibung des Meetingraumes'>" +
            "<label class='label'>Beschreibung des Agendapunktes</label>" +
            "<textarea id='agendaTopicDescription-" + itemId + "' maxlength='530' class='textarea codearea' placeholder='Beschreibungstext' name='EventToChange.Agenda[" + itemId + "].Description'>" + item.Description + "</textarea>" +
            "</div><br/>" +
            "<div class='control' data-tooltip='Upload des Vorschaubildes'>" +
            "<label class='label' >Agendabild hochladen</label>" +
            "<input type='hidden' name='EventToChange.Agenda[" + itemId + "].TeaserImageId' value='" + item.TeaserImageId + "' />" +
            "<div class='file has-name is-fullwidth'>" +
            "<label class='file-label'>" +
            "<input id='agendaTopicTeaserInput-" + itemId + "' class='file-input input' type='file' accept='image/png, image/jpeg, image/svg+xml' name='EventToChange.Agenda[" + itemId + "].TeaserImageChanged'>" +
            "<span class='file-cta'>" +
            "<span class='file-icon'><i class='fas fa-upload'></i></span>" +
            "<span class='file-label'>Datei wählen</span>" +
            "</span>" +
            "<span id='agendaTopicTeaserLabel-" + itemId + "' class='file-name'>Keine Datei ausgewählt</span>" +
            "</label>" +
            "</div>" +
            "<div class='is-centered'>" +
            "<figure class='image'>" +
            "<img id='agendaTopicTeaserPreview-" + itemId + "' src='" + teaserPreviewUrl + "'>" +
            "</figure>" +
            "</div>" +
            "</div><br/><hr/>" +
            "<div class='columns'>" +
            "<div class='column'>" +
            "<div class='control' data-tooltip='Schriftfarbe des Agendapunktes'>" +
            "<label class='label'>Schriftfarbe</label>" +
            "<input id='agendaTopicFontColor-" + itemId + "' type='color' class='input' name='EventToChange.Agenda[" + itemId + "].FontColor' value='" + item.FontColor + "'>" +
            "</div>" +
            "</div>" +
            "<div class='column'>" +
            "<div class='control' data-tooltip='Hintergrundfarbe des Agendapunktes'>" +
            "<label class='label'>Hintergrundfarbe</label>" +
            "<input id='agendaTopicBackground-" + itemId + "' type='color' class='input' name='EventToChange.Agenda[" + itemId + "].Background' value='" + item.Background + "'>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "<br>" +*/
            //Meetname
            "<div class='control' data-tooltip='Name des Meetings'>" +
            "<label class='label'>Name des Konferenzraums</label>" +
            "<input id='agendaMeetName-" + itemId + "' class='input' type='text' name='EventToChange.Agenda[" + itemId + "].MeetName' value='" + item.MeetName + "'>" +
            "</div>" +
            "<br>" +
            //Welcome Message
            "<div class='control' data-tooltip='Wilkommensnachricht, von allen Teilnehmern einsehbar'>" +
            "<label class='label'>Willkommensnachricht im Konferenzraum</label>" +
            "<input id='agendaMeetWelcomeMessage-" + itemId + "' class='input' type='text' name='EventToChange.Agenda[" + itemId + "].MeetWelcomeMessage' value='" + item.MeetWelcomeMessage + "'>" +
            "</div>" +
            "<br>" +
            //Welcome Message Moderator
            "<div class='control' data-tooltip='Wilkommensnachricht, nur von Moderatoren einsehbar'>" +
            "<label class='label'>Willkommensnachricht im Konferenzraum für Moderatoren</label>" +
            "<input id='agendaMeetWelcomeMessageModerator-" + itemId + "' class='input' type='text' name='EventToChange.Agenda[" + itemId + "].MeetWelcomeMessageModerator' value='" + item.MeetWelcomeMessageModerator + "'>" +
            "</div>" +
            "<br>" +
            //Meetbackgroundcolor
            "<div class='control' data-tooltip='Hintergrundfarbe des Meetingraumes'>" +
            "<label class='label'>Hintergrundfarbe des Konferenzraums</label>" +
            "<input id='agendaMeetBackgroundColor-" + itemId + "' type='color' class='input' name='EventToChange.Agenda[" + itemId + "].MeetBackgroundColor' value='" + item.MeetBackgroundColor + "'>" +
            "</div>" +
            "<br>" +
            //Logout url
            "<div class='control' data-tooltip='Url auf an die die Teilnehmer nach dem Ausloggen weitergeleitet werden sollen'>" +
            "<label class='label'>Logout Url</label>" +
            "<input id='agendaMeetLogoutUrl-" + itemId + "' class='input' type='text' name='EventToChange.Agenda[" + itemId + "].MeetLogoutUrl' value='" + item.MeetLogoutUrl + "'>" +
            "</div>" +
            "<br>" +
            //Logo
            "<div class='control' data-tooltip='Dieses Logo erscheint im Konferenzraum links über den Teilnehmern'>" +
            "<label class='label' >Konferenzraumlogo hochladen</label>" +
            "<input type='hidden' name='EventToChange.Agenda[" + itemId + "].MeetLogoId' value='" + item.MeetLogoId + "' />" +
            "<div class='file has-name is-fullwidth'>" +
            "<label class='file-label'>" +
            "<input id='agendaMeetLogoInput-" + itemId + "' class='file-input input' type='file' accept='pdf, pptx' name='EventToChange.Agenda[" + itemId + "].MeetLogoChanged'>" +
            "<span class='file-cta'>" +
            "<span class='file-icon'><i class='fas fa-upload'></i></span>" +
            "<span class='file-label'>Datei wählen</span>" +
            "</span>" +
            "<span id='agendaMeetLogoLabel-" + itemId + "' class='file-name'>Keine Datei ausgewählt</span>" +
            "</label>" +
            "</div>" +
            "<div class='is-centered'>" +
            "<figure class='image'>" +
            "<img id='agendaMeetLogoPreview-" + itemId + "' src='" + meetLogoUrl + "'>" +
            "</figure>" +
            "</div>" +
            "<br>" +
            //Meetingraum ID
            "<div class='control' data-tooltip='Die ID die im HTML Code verwendet werden kann'>" +
            "<label class='label'>Meetingraum ID</label>" +
            "<label>meetingroom-" + itemId + "</label>" +
            "</div>" +
            "</div><hr/>" +
            //andis changes ende
            "</div>";
            
        $(`#${this.divElementId}`).append(itemElement);

        $(`#agendaTopicTitle-${itemId}`).change(() => {
            this.itemList[itemId].Title = String($(`#agendaTopicTitle-${itemId}`).val());
        });

        $(`#agendaTopicStartTime-${itemId}`).change(() => {
            this.itemList[itemId].StartAt = new Date(String($(`#agendaTopicStartTime-${itemId}`).val()));
        });

        $(`#agendaTopicFinishTime-${itemId}`).change(() => {
            this.itemList[itemId].FinishAt = new Date(String($(`#agendaTopicFinishTime-${itemId}`).val()));
        });

        $(`#agendaTopicDescription-${itemId}`).change(() => {
            this.itemList[itemId].Description = String($(`#agendaTopicDescription-${itemId}`).val());
        });

        $(`#agendaTopicFontColor-${itemId}`).change(() => {
            this.itemList[itemId].FontColor = String($(`#agendaTopicFontColor-${itemId}`).val());
        });

        $(`#agendaTopicBackground-${itemId}`).change(() => {
            this.itemList[itemId].Background = String($(`#agendaTopicBackground-${itemId}`).val());
        });

        $(`#agendaTopicTeaserInput-${itemId}`).change(() => {
            console.log("IMAGE CHANGED");
            this.readUrl($(`#agendaTopicTeaserInput-${itemId}`)[0], `agendaTopicTeaserPreview-${itemId}`, `agendaTopicTeaserLabel-${itemId}`);
        });

        //meet
        $(`#agendaMeetName-${itemId}`).change(() => {
            this.itemList[itemId].MeetName = String($(`#agendaMeetName-${itemId}`).val());
        });

        $(`#agendaMeetWelcomeMessage-${itemId}`).change(() => {
            this.itemList[itemId].MeetWelcomeMessage = String($(`#agendaMeetWelcomeMessage-${itemId}`).val());
        });

        $(`#agendaMeetWelcomeMessageModerator-${itemId}`).change(() => {
            this.itemList[itemId].MeetWelcomeMessageModerator = String($(`#agendaMeetWelcomeMessageModerator-${itemId}`).val());
        });

        $(`#agendaMeetBackgroundColor-${itemId}`).change(() => {
            this.itemList[itemId].MeetBackgroundColor = String($(`#agendaMeetBackgroundColor-${itemId}`).val());
        });

        $(`#agendaMeetLogoutUrl-${itemId}`).change(() => {
            this.itemList[itemId].MeetLogoutUrl = String($(`#agendaMeetLogoutUrl-${itemId}`).val());
        });

        $(`#agendaMeetLogoInput-${itemId}`).change(() => {
            console.log("MEET IMAGE CHANGED");
            this.readUrl($(`#agendaMeetLogoInput-${itemId}`)[0], `agendaMeetLogoPreview-${itemId}`, `agendaMeetLogoLabel-${itemId}`);
        });

        $(`#agendaTopicFieldMoveUp-${itemId}`).click(() => {
            this.moveItem(MovingDirection.Up, itemId);
            this.redrawItems();
        });

        $(`#agendaTopicFieldMoveDown-${itemId}`).click(() => {
            this.moveItem(MovingDirection.Down, itemId);
            this.redrawItems();
        });

        $(`#agendaTopicFieldRemove-${itemId}`).click(() => {
            this.itemList.splice(itemId, 1);
            this.redrawItems();
        });
    }

    protected addNewItem() {
        const defaultAgendaDto: ChangeAgendaDto = {
            Background: "#D6D6D6",
            Description: "",
            FinishAt: new Date(Date.now()),
            FontColor: "#000000",
            StartAt: new Date(Date.now()),
            TeaserImageId: this.emptyGuidString,
            TeaserImageChanged: null,
            Title: "Titel",
            MeetLogoId: this.emptyGuidString,
            MeetPresentationId: this.emptyGuidString,
            MeetName: "Meetingname",
            MeetBackgroundColor: "#06172A",
            MeetLogoutUrl: "https://streamdiver.com",
            MeetWelcomeMessage: "Wilkommen zu Streamdiver Meet!<br>Hier finden Sie die Bedienungsanleitung: https://sdv.to/mud <br>Here you can find the user manual: https://sdv.to/mue",
            MeetWelcomeMessageModerator: "Wilkommen Moderator",
            ShortDescription: "",
            MeetLogoChanged: null,
            AgendaImageId: this.emptyGuidString,
            AgendaImageChanged: null,
            MeetPresentationChanged: null,
            PlayerContent: "",
            PlayerHeader: "",
            PlayerPreviewImageChanged: null,
            PlayerPreviewImageId: this.emptyGuidString,
            MeetJoinImageChanged: null,
            MeetJoinImageId: this.emptyGuidString            
        };
        this.itemList.push(defaultAgendaDto);
    }

    // See https://stackoverflow.com/questions/4459379/preview-an-image-before-it-is-uploaded
    protected readUrl(input, previewId, labelId) {
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (e !== null && e.target !== null) {
                    $("#" + previewId).prop("src", e.target.result);
                }
            }

            // Set input label
            reader.readAsDataURL(input.files[0]); // convert to base64 string
            $("#" + labelId).val(input.files[0].name);
        }
    }

    // Returns a date as string in the format yyyy-MM-ddThh:mm
    protected getDateTimeString(date: Date) {
        // For some strange reason, the parameter date can not be used directly ...
        // Therefore, another variable must be initialized
        const sameDate = new Date(date);
        return (`${sameDate.getFullYear().toString()}-${(`0${sameDate.getMonth() + 1}`).slice(-2)}-${(`0${sameDate.getDate()}`).slice(-2)}T${(`0${sameDate.getHours()}`).slice(-2)}:${(`0${sameDate.getMinutes()}`).slice(-2)}`)
    }
}